import Vue from 'vue';
import { getLabels } from '../../../services/map/layer';

export const mutations = {
    ADD_LAYER(state, { type, layerData, active, extended, filters, relations }) {
        const layer = {
            id: layerData.customId || layerData.id,
            active,
            type,
            data: layerData,
            extended,
            filters,
            relations,
            error: null
        };
        const layers = state.layers.filter(_layer => _layer.id !== layer.id);
        state.layers = [...layers, layer];
    },
    REMOVE_LAYER(state, { id }) {
        state.layers = state.layers.filter(_layer => _layer.id !== id);
    },
    TOGGLE_LAYER(state, { id, active }) {
        const layer = state.layers.find(_layer => _layer.id === id);
        layer.active = active ?? !layer.active;
        Vue.set(state, 'layers', state.layers);
    },
    SET_LAYER_ERROR_STATE(state, { id, error }) {
        const layer = state.layers.find(_layer => _layer.id === id);
        layer.error = error;
        if (layer.error) {
            layer.active = false;
        }
        Vue.set(state, 'layers', state.layers);
    },

    SET_LAYER_CHECKED_STATE(state, { id, checked }) {
        const layer = state.layers.find(_layer => _layer.id === id);
        layer.checked = checked;
        Vue.set(state, 'layers', state.layers);
    },

    SET_SOURCE_WFS_OUTPUT_FORMAT(state, { id, format }) {
        const source = state.sources.find(_source => _source.id === id);

        if (!source) {
            const source = { id: id, wfsOutputFormat: format };
            state.sources.push(source);
        } else {
            source.wfsOutputFormat = format;
        }
        Vue.set(state, 'sources', state.sources);
    },

    SET_SOURCE_WMS_OUTPUT_FORMAT(state, { id, format }) {
        const source = state.sources.find(_source => _source.id === id);

        if (!source) {
            const source = { id: id, wmsOutputFormat: format };
            state.sources.push(source);
        } else {
            source.wmsOutputFormat = format;
        }
        Vue.set(state, 'sources', state.sources);
    },

    SET_LAYER_STYLE(state, { layerCustomId, styleName, legendUrl }) {
        const layer = state.layers.find(_layer => _layer.id === layerCustomId);
        // Save style
        if (layer.data.styles) {
            layer.data.styles[0].name = styleName;
        }
        if (legendUrl && layer.data.customEndPoints) {
            layer.data.customEndPoints.legend.url = legendUrl;
        }
        // Save custom endpoint legend
        Vue.set(state, 'layers', state.layers);
    },

    SET_LAYER_HIDE_POLYGON_FILL(state, { layerCustomId, hidePolygonFill }) {
        const layer = state.layers.find(_layer => _layer.id === layerCustomId);
        // Save style
        layer.hidePolygonFill = hidePolygonFill;
        // Save custom endpoint legend
        Vue.set(state, 'layers', state.layers);
    },
    async SET_ATTRIBUTES_AS_LABEL(state, { layerId, attributes }) {
        if (state.layers.length > 0) {
            // find layer
            let layer = state.layers.find(l => l.id === layerId);

            if (layer) {
                // find attribute
                attributes.forEach(function (attribute) {
                    let informationAttribute = layer.extended.informationAttributes.find(i => i.id === attribute.id);

                    if (informationAttribute) {
                        // set attribute to given state
                        informationAttribute.isTextAttribute = attribute.isTextAttribute;
                    }
                });

                // update labels for layer
                layer.extended.computedStyles[0].settings.default.labels = getLabels(layer.extended.informationAttributes);

            }
        }
    },
    SET_DEFAULT_ATTRIBUTE_LABELS(state, { layerId }) {
        if (state.layers.length > 0) {
            // find layer
            let layer = state.layers.find(l => l.id === layerId);

            // For every informationAttribute
            layer.extended.informationAttributes.forEach(function (attribute) {

                // Search for it in the default Attributes
                let defaultAttribute = layer.extended.defaultAttributes.find(i => i.id === attribute.id);

                if (defaultAttribute) {
                    // set attribute to default state
                    attribute.isTextAttribute = defaultAttribute.isTextAttribute;
                    attribute.textAttributeShowLabel = defaultAttribute.textAttributeShowLabel;
                    attribute.textAttributeSeparator = defaultAttribute.textAttributeSeparator;
                } else {
                    attribute.isTextAttribute = false;
                }
            });

            // update labels for layer
            layer.extended.computedStyles[0].settings.default.labels = getLabels(layer.extended.informationAttributes);
        }
    },
    async SET_HAS_LABELS(state, { layerId, hasLabels }) {
        if (state.layers.length > 0) {
            // find layer
            let layer = state.layers.find(l => l.id === layerId);

            if (layer) {
                layer.extended.hasGraphicalLayerAndStyleTextAttribute = hasLabels;
            }
        }
    },
    ADD_LAYERS_3D(state, { layers3D }) {
        if (layers3D && layers3D.length > 0) {
            layers3D.forEach(function (layer3D) {
                layer3D.active = false;
            });
            state.layers3D = [...layers3D];
        }
    },
    SET_LAYER_3D(state, { layer3D, index }) {
        let layer = state.layers3D.find(l => l.id === layer3D.id);
        layer.active = layer3D.active;
        layer.index = index;
    }
};
